import type { RouteRecordRaw } from 'vue-router';

export const constantRoutes: RouteRecordRaw[] = [
  { path: '/login', name: 'Login', component: () => import('@/views/login/index.vue'), meta: { hidden: true, title: 'Login' } },
  { path: '/forgot-password', name: 'ForgotPassword', component: () => import('@/views/forgot-password/index.vue'), meta: { hidden: true, title: 'Forgot Password' } },
  { path: '/reset-password', name: 'ResetPassword', component: () => import('@/views/reset-password/index.vue'), meta: { hidden: true, title: 'Reset Password' } },
  { path: '/403', name: 'Forbidden', component: () => import('@/views/error/403.vue'), meta: { hidden: true, title: '403' } },
  { path: '/404', name: 'NotFound', component: () => import('@/views/error/404.vue'), meta: { hidden: true, title: '404' } },
  {
    path: '/interview_invitation',
    name: 'interviewInvitation',
    component: () => import('@/views/interview_invitation/index.vue'),
    meta: { title: 'interview.interviewInvitation', icon: 'List', roles: ['admin'] }
  },
  {
    path: '/job-preview',
    name: 'JobPreview',
    component: () => import('@/views/job-preview/index.vue'),
  }
];
